import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;